<template>
  <div class="report-dashboard">
    <quick-info-section>
      <el-row :gutter="0">
        <el-col :span="8">
          <h2 class="ma-0">Report Dashboard</h2>
        </el-col>
        <el-col :span="16" class="align-right">
          <el-select v-model="selectedOffice" :clearable="selectedOffice !== null" placeholder="All Offices">
            <el-option v-for="item in allOffices" :key="item.id" :label="'#' + item.storeNum + ' - ' + item.address"
              :value="item.id">
            </el-option>
          </el-select>
          <el-date-picker v-show="showDateRangePicker" v-model="dateRange" :clearable="false"
            :picker-options="datePickerOptions" type="daterange" range-separator="To" start-placeholder="Start date"
            end-placeholder="End date" unlink-panels>
          </el-date-picker>
        </el-col>
      </el-row>
    </quick-info-section>
    <router-view :date-range="dateRange" :selected-office="selectedOffice"> </router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import QuickInfoSection from '@/components/layout/QuickInfoSection.vue';

const startOfYear = moment('2025-01-01');
const weekAfterStartOfYear = moment(startOfYear).add(1, 'week');
const defaultEndDate = weekAfterStartOfYear.isBefore(moment())
  ? moment('2025-04-30')
  : weekAfterStartOfYear;

export default {
  components: {
    QuickInfoSection,
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
  },
  computed: {
    ...mapGetters('Lookup', ['allOffices']),
    showDateRangePicker() {
      return this.$route.name !== 'reportScheduling';
    },
  },
  data() {
    return {
      selectedOffice: null,
      dateRange: [startOfYear.format(), defaultEndDate.format()],
      datePickerOptions: {},
    };
  },
  mounted() {
    this.getOffices();
  },
};
</script>

<style lang="scss">
.chart-holder>div {
  position: relative;
  display: block;
  max-width: 100%;
  max-height: 400px;
}

.donut-holder>div {
  position: relative;
  display: block;
  max-width: 100%;
  max-height: 300px;
}
</style>
